import React, { Component } from "react";
import Layout from "@pages/candidate/Layout";
import {
    Heading,
    Container,
    Box,
} from "@chakra-ui/react";
import { Separator, View, OfferItem, OfferSkeleton, LoadMore } from '@components';
import { getFavoriteOffers } from "@lib/datahandlers/person";
import { t } from '@lang/i18n';
import { AuthContext } from '@contexts/AuthContext';
import { PER_PAGE } from '@lib/constants';

class FavoriteOffersScreen extends Component {
    static contextType = AuthContext;

    state = {
        loading_more: false,
        has_more: true,
        loading: false,
        offers: [],
        page: 1,
    };

    componentDidMount() {
        document.title = t('candidate.favourite_offers.page_title');;
        this.getOffers();
    }

    getOffers = async () => {
        this.setState({ loading: true });
        const response = await getFavoriteOffers(this.state.page);
        this.setState({ loading: false });

        if (response) this.setState({
            offers: response.offers,
            has_more: response.offers.length === PER_PAGE,
        });
        else this.context.toast({ description: t('global.general_error'), status: "warning", variant: 'subtle', duration: 3000 });
    }

    showMore = async () => {
        let nextPage = this.state.page + 1;

        this.setState({ loading_more: true });
        const response = await getFavoriteOffers(nextPage);
        this.setState({ loading_more: false });

        if (response) {
            this.setState({
                offers: [...this.state.offers, ...response.offers],
                has_more: response.offers.length === PER_PAGE,
                page: nextPage,
            });
        }
        else this.context.toast({ description: t('global.general_error'), status: "warning", variant: 'subtle', duration: 3000 });
    }

    render() {
        return (
            <Layout menuType="candidate" isNavBarVisible isFooterVisible>

                <Container maxW="container.md" bg="#FFFC" minHeight='calc(100vh - 100px)' py="36px" px={["16px", "", "", "100px"]}>
                    <Heading textAlign="center" fontSize="30px" m="auto" maxW="435px"> {t('candidate.favourite_offers.title')} </Heading>
                    <Separator />

                    {/* No results */}
                    <View if={!this.state.offers.length && !this.state.loading}>
                        <Box m="auto" textAlign="center">
                            <Heading m="auto" mt="80px" maxW="600px" fontWeight="500" color="#999" fontSize="20px">
                                {t('candidate.search_job.main.search_none')}
                            </Heading>
                        </Box>
                    </View>

                    {/* Loading */}
                    <View
                        if={this.state.loading}
                        className={'fadeIn'}
                        mx="-17px"
                        display="flex"
                        flexDir="row"
                        flexWrap="wrap"
                        justifyContent={["center", "", "", "space-between"]} >
                        {[1, 2, 3].map(e => (<OfferSkeleton key={e} />))}

                    </View>

                    {/* Listing */}
                    <View
                        if={this.state.offers.length && !this.state.loading}
                        mx="-17px"
                        display="flex"
                        flexDir="row"
                        flexWrap="wrap"
                        justifyContent={["center", "", "", "space-between"]} >

                        {/* Number of results */}
                        <Heading flexBasis="100%" textAlign={["center", "", "", "left"]} fontWeight="600" fontSize="16px" ml="14px">
                            {t('candidate.favourite_offers.description')}
                        </Heading>

                        {/* Results */}
                        {this.state.offers.map((offer, index) => (
                            <OfferItem key={index} data={offer} />
                        ))}

                        {/* Pagination */}
                        <View if={this.state.has_more} flexBasis="100%" textAlign="center">
                            <LoadMore showMore={this.showMore} loading_more={this.state.loading_more} />
                        </View>
                    </View>

                </Container>
            </Layout>
        )
    }
}

export default FavoriteOffersScreen;